// Platform announcement banner (ADMIN_UPGRADE_PLAN feature 48).
// Content is set by Tagnologys staff in /padmin → Security & platform, and
// stored at platform/config.announcement. Bilingual: the Arabic copy is used
// when the UI is in Arabic, falling back to English if it is blank.
//
// Reads Firestore directly — `platform/{doc}` is readable by any signed-in user
// (firestore.rules), and this is a single small doc.
import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { useI18n } from '../../lib/i18n';

interface Announcement { enabled?: boolean; text?: string; textAr?: string }

export default function AnnouncementBar() {
  const { lang, t } = useI18n();
  const [ann, setAnn] = useState<Announcement | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => onSnapshot(
    doc(db, 'platform', 'config'),
    (snap) => setAnn((snap.data()?.announcement as Announcement) ?? null),
    () => setAnn(null), // config unreadable or absent — show nothing
  ), []);

  const body = (lang === 'ar' ? ann?.textAr || ann?.text : ann?.text) ?? '';
  if (!ann?.enabled || !body.trim() || dismissed) return null;

  return (
    <div className="flex items-start gap-3 bg-ink px-4 py-2.5 text-white sm:px-6">
      <span aria-hidden>📣</span>
      <p className="min-w-0 flex-1 text-[13px] font-semibold">{body}</p>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label={t('common.dismiss')}
        className="flex-shrink-0 text-white/70 hover:text-white"
      >
        ✕
      </button>
    </div>
  );
}
